// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__20zA6","footer":"ModalInfo_footer__1hAH-"};